import { ResponsiveModal } from "@tiendeo/react-components/dist/objects/Modal/ResponsiveModal";
import {
    StyledWrapper,
    StyledTitle,
    NotificationRadio,
    ButtonsWrapper,
    RadioInput,
    ButtonWrapper,
} from "./DeleteNotificationsModal.styles";
import useTranslation from "translations/useTranslation";
import { TextMedium } from "@tiendeo/react-components/dist/Typography";
import StyledButton, { Variants } from "ui/components/Button/Button";
import { useState } from "react";

interface DeleteNotificationsModalProps {
    isOpen: boolean;
    handleNewsletter: (newsletter: boolean, hash: string, noAlerts?: boolean) => void;
    newsletter: boolean;
    hash: string;
    onClose: () => void;
    handleDelete: (selectedReason: number) => void;
}

const DeleteNotificationsModal = ({
    isOpen,
    onClose,
    handleDelete,
    newsletter,
    handleNewsletter,
    hash,
}: DeleteNotificationsModalProps) => {
    const t = useTranslation();
    const [reason, setReason] = useState<number>();

    const surveyOptions = [
        {
            text: t("DELETE_ALERTS_SURVEY_OPTION_1"),
            value: 1,
        },
        {
            text: t("DELETE_ALERTS_SURVEY_OPTION_2"),
            value: 2,
        },
        {
            text: t("DELETE_ALERTS_SURVEY_OPTION_3"),
            value: 3,
        },
        {
            text: t("DELETE_ALERTS_SURVEY_OPTION_4"),
            value: 4,
        },
    ];

    const renderSurvey = surveyOptions.map((option) => {
        return (
            <NotificationRadio key={option.value}>
                <RadioInput
                    type="radio"
                    value={option.value}
                    onClick={() => {
                        setReason(option.value);
                    }}
                    checked={reason === option.value}
                />
                <TextMedium>{option.text}</TextMedium>
            </NotificationRadio>
        );
    });

    return (
        <ResponsiveModal isOpen={isOpen} onClose={onClose}>
            <StyledWrapper>
                <StyledTitle>{t("DELETE_SURVEY_POPUP_TEXT")}</StyledTitle>
                {renderSurvey}
                <ButtonsWrapper>
                    <StyledButton
                        variant={Variants.TEXT}
                        color={"secondary"}
                        onClick={() => {
                            handleDelete(-1);
                            handleNewsletter(newsletter, hash);
                            onClose();
                        }}
                    >
                        <TextMedium>{t("DONT_SEND")}</TextMedium>
                    </StyledButton>
                    <ButtonWrapper>
                        <StyledButton
                            variant={Variants.OUTLINE}
                            color={"secondary"}
                            onClick={onClose}
                        >
                            <TextMedium>{t("CANCEL")}</TextMedium>
                        </StyledButton>
                    </ButtonWrapper>
                    <StyledButton
                        variant={Variants.SOLID}
                        color={"primary"}
                        onClick={() => {
                            handleDelete(reason);
                            handleNewsletter(newsletter, hash);
                            onClose();
                        }}
                        status={reason ? "active" : "disabled"}
                    >
                        <TextMedium>{t("SEND")}</TextMedium>
                    </StyledButton>
                </ButtonsWrapper>
            </StyledWrapper>
        </ResponsiveModal>
    );
};

export default DeleteNotificationsModal;
